// these are values for the query params
export const PageStatusFilterValueKey: {
	readonly RoughDraft: 'roughDraft';
	readonly InProgress: 'inProgress';
	readonly ReadyForReview: 'readyForReview';
	readonly Verified: 'verified';
} = {
	RoughDraft: 'roughDraft',
	InProgress: 'inProgress',
	ReadyForReview: 'readyForReview',
	Verified: 'verified',
} as const;
export type PageStatusFilterValueKey =
	(typeof PageStatusFilterValueKey)[keyof typeof PageStatusFilterValueKey];
export const allPageStatusFilterValueKeys: (
	| 'verified'
	| 'roughDraft'
	| 'inProgress'
	| 'readyForReview'
)[] = Object.values(PageStatusFilterValueKey);

// these are the values that will be passed into the GQL query under ConfluenceFilters' pageStatus
export const PageStatusFilterValue: Record<PageStatusFilterValueKey, string> = {
	[PageStatusFilterValueKey.RoughDraft]: 'Rough draft',
	[PageStatusFilterValueKey.InProgress]: 'In progress',
	[PageStatusFilterValueKey.ReadyForReview]: 'Ready for review',
	[PageStatusFilterValueKey.Verified]: 'Verified',
} as const;

export const isPageStatusFilterValueKey = (value: string): value is PageStatusFilterValueKey => {
	return allPageStatusFilterValueKeys.includes(value as PageStatusFilterValueKey);
}